// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageUpload_wrap__PBGJo {
  display: grid;
  gap: 8px;
}

.ImageUpload_labelRow__vYCv4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ImageUpload_label__mii-v {
  font-weight: 600;
}

.ImageUpload_linkBtn__ACPHp {
  border: 0;
  background: transparent;
  color: #0d263f;
  cursor: pointer;
}

.ImageUpload_box__arp4l {
  display: flex;
  gap: 12px;
  align-items: center;
}

.ImageUpload_placeholder__I6pZ3, .ImageUpload_preview__OXCz5 {
  width: 220px;
  height: 140px;
  border: 1px dashed #d9dfe8;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: #fff;
  cursor: pointer;
}

.ImageUpload_placeholder__I6pZ3 .ImageUpload_hint__03Jg2 {
  font-size: 12px;
  opacity: 0.6;
}

.ImageUpload_preview__OXCz5 img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 12px;
  display: block;
}

.ImageUpload_actions__w779W {
  display: flex;
  gap: 8px;
}

.ImageUpload_btn__yphvj {
  background: #0d263f;
  color: #fff;
  border: 0;
  border-radius: 10px;
  padding: 8px 12px;
  cursor: pointer;
}

.ImageUpload_btnGhost__dTXup {
  background: transparent;
  color: #0d263f;
  border: 1px solid #0d263f;
  border-radius: 10px;
  padding: 8px 12px;
  text-decoration: none;
}

.ImageUpload_err__GkVLH {
  color: #c62828;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/modules/news/ImageUpload.module.scss"],"names":[],"mappings":"AAAA;EAAQ,aAAA;EAAe,QAAA;AAGvB;;AAFA;EAAY,aAAA;EAAe,mBAAA;EAAqB,8BAAA;AAQhD;;AAPA;EAAS,gBAAA;AAWT;;AAVA;EAAW,SAAA;EAAW,uBAAA;EAAyB,cAAA;EAAgB,eAAA;AAiB/D;;AAfA;EAAO,aAAA;EAAe,SAAA;EAAW,mBAAA;AAqBjC;;AApBA;EACE,YAAA;EAAc,aAAA;EACd,0BAAA;EAA4B,mBAAA;EAC5B,aAAA;EAAe,mBAAA;EACf,gBAAA;EAAkB,eAAA;AA2BpB;;AAzBA;EAAqB,eAAA;EAAiB,YAAA;AA8BtC;;AA7BA;EAAe,eAAA;EAAiB,gBAAA;EAAkB,mBAAA;EAAqB,cAAA;AAoCvE;;AAlCA;EAAW,aAAA;EAAe,QAAA;AAuC1B;;AAtCA;EACE,mBAAA;EAAqB,WAAA;EAAa,SAAA;EAAW,mBAAA;EAAqB,iBAAA;EAAmB,eAAA;AA8CvF;;AA5CA;EACE,uBAAA;EAAyB,cAAA;EAAgB,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,qBAAA;AAoD9G;;AAlDA;EAAO,cAAA;EAAgB,eAAA;AAuDvB","sourcesContent":[".wrap { display: grid; gap: 8px; }\r\n.labelRow { display: flex; align-items: center; justify-content: space-between; }\r\n.label { font-weight: 600; }\r\n.linkBtn { border: 0; background: transparent; color: #0d263f; cursor: pointer; }\r\n\r\n.box { display: flex; gap: 12px; align-items: center; }\r\n.placeholder, .preview {\r\n  width: 220px; height: 140px;\r\n  border: 1px dashed #d9dfe8; border-radius: 12px;\r\n  display: grid; place-items: center;\r\n  background: #fff; cursor: pointer;\r\n}\r\n.placeholder .hint { font-size: 12px; opacity: .6; }\r\n.preview img { max-width: 100%; max-height: 100%; border-radius: 12px; display: block; }\r\n\r\n.actions { display: flex; gap: 8px; }\r\n.btn {\r\n  background: #0d263f; color: #fff; border: 0; border-radius: 10px; padding: 8px 12px; cursor: pointer;\r\n}\r\n.btnGhost {\r\n  background: transparent; color: #0d263f; border: 1px solid #0d263f; border-radius: 10px; padding: 8px 12px; text-decoration: none;\r\n}\r\n.err { color: #c62828; font-size: 14px; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ImageUpload_wrap__PBGJo`,
	"labelRow": `ImageUpload_labelRow__vYCv4`,
	"label": `ImageUpload_label__mii-v`,
	"linkBtn": `ImageUpload_linkBtn__ACPHp`,
	"box": `ImageUpload_box__arp4l`,
	"placeholder": `ImageUpload_placeholder__I6pZ3`,
	"preview": `ImageUpload_preview__OXCz5`,
	"hint": `ImageUpload_hint__03Jg2`,
	"actions": `ImageUpload_actions__w779W`,
	"btn": `ImageUpload_btn__yphvj`,
	"btnGhost": `ImageUpload_btnGhost__dTXup`,
	"err": `ImageUpload_err__GkVLH`
};
export default ___CSS_LOADER_EXPORT___;
